import type { Immutable } from "immer";
import React from "react";

import type { OfferBannerBlock as OfferBannerBlockValue } from "@reactivated";

export const OfferBannerBlock = (
    props: Immutable<{ value: OfferBannerBlockValue }>,
): React.JSX.Element => {
    return (
        <div className="offer-banner-block">
            <div className="l-full-width">
                <div className="offer-banner-block__content">
                    <div
                        className="rich-text"
                        dangerouslySetInnerHTML={{
                            __html: props.value.copy ?? "",
                        }}
                    />
                    <div
                        className={`offer-banner-block__bar offer-banner-block__bar--${
                            props.value.line_type ?? ""
                        }`}
                    />
                </div>
            </div>
        </div>
    );
};
